// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'Angolo Speedtest',
    appLogoImage: require('@src/assets/images/logo/angolo-v2-light.svg').default,
    appLogoImageDark: require('@src/assets/images/logo/angolo-v2-dark.svg').default,
    appLogoText: require('@src/assets/images/logo/testo.svg').default

  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    type: 'horizontal', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'static', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
